import { useState, useEffect, useRef } from "react";
import { Button } from "@/components/ui/button";
import AdBlock from "@/components/AdBlock";
import { PlayCircle, X } from "lucide-react";

export default function RewardAdModal({ open, seconds = 30, title, slotId, onComplete, onClose }) {
  const [left, setLeft] = useState(seconds);
  const timer = useRef(null);

  useEffect(() => {
    if (!open) return;
    setLeft(seconds);
    timer.current = setInterval(() => setLeft((l) => (l <= 1 ? (clearInterval(timer.current), 0) : l - 1)), 1000);
    return () => clearInterval(timer.current);
  }, [open, seconds]);

  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[70] bg-black/90 flex items-center justify-center p-4 animate-fade-in" data-testid="reward-ad-modal">
      <div className="w-full max-w-lg">
        <div className="flex items-center justify-between mb-3">
          <p className="text-sm font-semibold">{title || "Sponsored Video"}</p>
          <button data-testid="reward-ad-close" onClick={onClose} className="text-muted-foreground hover:text-white"><X className="w-5 h-5" /></button>
        </div>
        {/* Ad script injection target */}
        <AdBlock id={slotId} size="300x250" label="300x250 Sponsored" className="w-[300px] h-[250px] mx-auto" />
        <div className="flex items-center justify-between mt-4">
          <span className="text-sm text-muted-foreground">
            {left > 0 ? `Reward unlocks in ${left}s…` : "Reward ready!"}
          </span>
          <div className="flex gap-2">
            <button data-testid="reward-ad-skip" onClick={onComplete} className="text-xs text-muted-foreground hover:text-white underline">Skip (demo)</button>
            <Button data-testid="reward-ad-claim" disabled={left > 0} onClick={onComplete}
              className="h-10 px-5 rounded-full bg-brand hover:bg-brand-hover text-white transition-colors disabled:opacity-40">
              <PlayCircle className="w-4 h-4 mr-2" /> Claim
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
